/** Tailwind class constants for ThemeColorPicker + ColorWheelPicker — no CSS/SCSS. */

export const themeColorRoot = 'relative inline-flex items-center';

export const themeColorTrigger =
  'inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border border-[var(--inv-border,#e8dfd2)] bg-[var(--inv-surface,#fff)] p-0 transition-[border-color,transform] duration-150 hover:-translate-y-px hover:border-[var(--inv-border-strong,#d4c4b0)] focus-visible:-translate-y-px focus-visible:border-[var(--inv-border-strong,#d4c4b0)] focus-visible:outline-none';

export const themeColorTriggerSwatch =
  'block h-4 w-4 rounded-full shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)]';

/** Mobile: fixed centered overlay. Desktop: dropdown under the trigger. */
export const themeColorBackdrop =
  'fixed inset-0 z-[140] bg-black/30 min-[901px]:hidden';

export const themeColorPanel =
  'z-[150] max-h-[min(90dvh,42rem)] w-[min(21rem,calc(100vw-1.5rem))] overflow-y-auto overscroll-contain rounded-[14px] border border-[var(--inv-border,#e8dfd2)] bg-[var(--inv-surface,#fff)] p-4 shadow-[0_18px_40px_rgba(43,33,24,0.16)] ' +
  'fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 ' +
  'min-[901px]:absolute min-[901px]:left-auto min-[901px]:right-0 min-[901px]:top-[calc(100%+0.6rem)] min-[901px]:max-h-[min(80vh,42rem)] min-[901px]:w-[21rem] min-[901px]:translate-x-0 min-[901px]:translate-y-0';

export const themeColorHeader = 'mb-[0.85rem]';

export const themeColorTitle =
  'text-[0.9375rem] font-bold text-[var(--inv-text,#2b2118)]';

export const themeColorDesc =
  'mt-1 text-xs leading-[1.4] text-[var(--inv-text-muted,#a89584)]';

export const themeColorSection = 'mt-[0.9rem]';

export const themeColorSectionLabel =
  'mb-2 text-[0.5625rem] font-bold uppercase tracking-[0.12em] text-[var(--inv-text-muted,#a89584)]';

export const themeColorCombos = 'flex flex-col gap-[0.35rem]';

export const themeColorCombo =
  'flex w-full cursor-pointer items-center gap-[0.6rem] rounded-[10px] border border-[var(--inv-border,#e8dfd2)] bg-[var(--inv-surface,#fff)] px-[0.6rem] py-2 text-left transition-[border-color,background] duration-150 hover:border-[var(--inv-border-strong,#d4c4b0)] hover:bg-[var(--inv-surface-muted,#faf6f0)] focus-visible:border-[var(--inv-border-strong,#d4c4b0)] focus-visible:bg-[var(--inv-surface-muted,#faf6f0)] focus-visible:outline-none';

export const themeColorComboActive =
  'border-[var(--inv-accent,#0046b8)] bg-[var(--inv-accent-soft,#e6efff)]';

export const themeColorComboDots = 'inline-flex shrink-0';

export const themeColorComboDot =
  'h-[1.05rem] w-[1.05rem] rounded-full shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)] [&+&]:-ml-[0.45rem]';

export const themeColorComboLabel =
  'flex-1 text-[0.8125rem] font-semibold text-[var(--inv-text,#2b2118)]';

export const themeColorComboTag =
  'text-[0.625rem] font-semibold text-[var(--inv-text-muted,#a89584)]';

export const themeColorSwatches = 'grid grid-cols-8 gap-[0.4rem]';

export const themeColorSwatch =
  'relative aspect-square w-full cursor-pointer rounded-full border-0 p-0 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)] transition-transform duration-100 hover:scale-110 focus-visible:scale-110 focus-visible:outline-none';

export const themeColorSwatchActive =
  'shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08),0_0_0_2px_var(--inv-surface,#fff),0_0_0_4px_var(--inv-text,#2b2118)]';

export const themeColorFooter =
  'mt-4 flex justify-end border-t border-[var(--inv-border-soft,#efe6da)] pt-3';

export const themeColorReset =
  'cursor-pointer rounded-md border-0 bg-transparent px-[0.35rem] py-1 text-xs font-semibold text-[var(--inv-accent,#0046b8)] hover:bg-[var(--inv-accent-soft,#e6efff)] focus-visible:bg-[var(--inv-accent-soft,#e6efff)] focus-visible:outline-none';

export const colorWheelRoot =
  'flex w-full min-w-0 max-w-full flex-col items-center gap-3';

export const colorWheelWheel = 'relative touch-none select-none';

export const colorWheelRing =
  'absolute inset-0 z-0 cursor-crosshair rounded-full bg-[conic-gradient(from_0deg,#ff0000,#ffff00,#00ff00,#00ffff,#0000ff,#ff00ff,#ff0000)]';

export const colorWheelRingHole =
  'pointer-events-none absolute inset-[22px] rounded-full bg-[var(--inv-surface,#fff)]';

export const colorWheelSl =
  'absolute z-[1] cursor-crosshair rounded-lg bg-[linear-gradient(to_top,#000,transparent),linear-gradient(to_right,#fff,transparent)] shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)]';

export const colorWheelHandle =
  'pointer-events-none absolute z-[2] h-[0.85rem] w-[0.85rem] -translate-x-1/2 -translate-y-1/2 rounded-full shadow-[0_0_0_2px_#fff,0_0_0_3px_rgba(0,0,0,0.25)]';

export const colorWheelHandleRing = 'bg-white';

export const colorWheelHandleSl = 'border border-white/65';

export const colorWheelHexRow =
  'box-border flex w-full min-w-0 max-w-full items-center gap-[0.55rem]';

export const colorWheelPreview =
  'h-7 w-7 shrink-0 rounded-lg shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)]';

export const colorWheelHexLabel = 'box-border min-w-0 flex-1 overflow-hidden';

export const colorWheelHexInput =
  'box-border min-w-0 w-full max-w-full rounded-lg border border-[var(--inv-border,#e8dfd2)] bg-[var(--inv-surface-muted,#faf6f0)] px-[0.6rem] py-[0.45rem] font-mono text-[0.8125rem] tracking-[0.02em] text-[var(--inv-text,#2b2118)] focus-visible:border-[var(--inv-accent,#c94f1c)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--inv-accent-ring,rgba(201,79,28,0.08))]';
